import './index.css';
import reportWebVitals from './reportWebVitals';
import { startStandaloneApp } from './util/boot-standalone';

startStandaloneApp();
reportWebVitals();
